import isBlank from 'is-blank'

export default taggings => {
  if (taggings.constructor !== Array) {
    throw new TypeError('taggings has to be an array.')
  }

  return taggings.map(tag => tag.slug).join(', ')
}



// WEBPACK FOOTER //
// ./src/filters/tags.js